import { useOptimizelyFlag } from 'src/services/flags/hooks/useOptimizelyFlag';

export function useIsPaypalVStripeVariantFlagEnabled(): boolean {
  return useOptimizelyFlag('paypal_v_stripe_variant').enabled;
}
